(function () {
  var KEY = 'mypiece_wishlist';
  var T = {
    added: 'Bewaard in je verlanglijst',
    removed: 'Verwijderd uit je verlanglijst',
    error: 'Dat is niet gelukt. Probeer het opnieuw.'
  };

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function set(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return get().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = get();
    var i = list.indexOf(handle);
    var added;
    if (i === -1) { list.push(handle); added = true; }
    else { list.splice(i, 1); added = false; }
    set(list);
    return added;
  }

  function money(cents) {
    try { return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return '€' + (cents / 100).toFixed(2); }
  }

  function toast(msg) {
    var el = document.getElementById('mp-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mp-toast';
      el.className = 'mp-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function refreshHearts() {
    var list = get();
    document.querySelectorAll('[data-mp-heart]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-mp-heart')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Verwijderen uit verlanglijst' : 'Toevoegen aan verlanglijst');
    });
  }

  function updateCount() {
    var n = get().length;
    document.querySelectorAll('[data-mp-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mp-heart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    try {
      var added = toggle(btn.getAttribute('data-mp-heart'));
      refreshHearts();
      updateCount();
      toast(added ? T.added : T.removed);
      if (document.getElementById('mp-wishlist-grid')) renderWishlistPage();
    } catch (err) { toast(T.error); }
  });

  function renderWishlistPage() {
    var grid = document.getElementById('mp-wishlist-grid');
    var empty = document.getElementById('mp-wishlist-empty');
    if (!grid) return;
    var handles = get();
    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = '';
      products.filter(Boolean).forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var card = document.createElement('div');
        card.className = 'mp-wl-card';
        card.innerHTML =
          '<button class="mp-heart is-active" data-mp-heart="' + p.handle + '" aria-label="Verwijderen uit verlanglijst" aria-pressed="true">' + heartSvg() + '</button>' +
          '<a class="mp-wl-card__media" href="' + p.url + '">' + (img ? '<img src="' + img + '&width=600" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="mp-wl-card__title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="mp-wl-card__price">' + (p.price_varies ? 'Vanaf ' : '') + money(p.price) + '</div>';
        grid.appendChild(card);
      });
      refreshHearts();
    });
  }

  function heartSvg() {
    return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-8.5C.4 9.9 1.3 6.5 4.3 5.4c2-.7 4 .1 5.2 1.7L12 9.9l2.5-2.8c1.2-1.6 3.2-2.4 5.2-1.7 3 1.1 3.9 4.5 2.3 7.1C19.5 16.4 12 21 12 21z"/></svg>';
  }

  function init() {
    refreshHearts();
    updateCount();
    renderWishlistPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
